import { BaseButton } from 'app/components/buttons/BaseButton';
import { ChevronDownIcon } from 'app/components/icons';
import { ActionsListItem, Menu } from 'app/components/menu';
import clsx from 'clsx';
import React, { useCallback, useMemo, useState } from 'react';
import './Select.less';
import { SelectOption, SelectOptionType } from './type';

interface Props<T extends SelectOptionType> {
  value?: T;
  options: SelectOption<T>[];
  onChange: (value: T) => void;
}

export default function Select<T extends SelectOptionType>({
  value,
  options,
  onChange,
}: Props<T>) {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | undefined>(undefined);

  const handleMenuOpen = useCallback(
    (event: React.MouseEvent<HTMLButtonElement>) => {
      event.stopPropagation();
      const element = event.currentTarget;

      setAnchorEl(prev => (!prev ? element : undefined));
    },
    [],
  );

  const actions: ActionsListItem[] = useMemo(
    () =>
      options.map(({ label, value }) => {
        return { label, action: () => onChange(value) };
      }),
    [options, onChange],
  );

  const label = useMemo(() => {
    if (!value) {
      return '';
    }

    return options.find(option => option.value === value)?.label ?? '';
  }, [value, options]);

  return (
    <>
      <BaseButton
        className={clsx('base-select__button', {
          'base-select__button_open': anchorEl,
        })}
        onClick={handleMenuOpen}
      >
        {label && <span className="base-select__label">{label}</span>}
        <ChevronDownIcon stroke="#909090" />
      </BaseButton>

      <Menu
        anchorEl={anchorEl}
        actions={actions}
        onClose={() => setAnchorEl(undefined)}
      />
    </>
  );
}
